import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {GestionProcessusRoutingModule} from './gestion-processus-routing.module';
import {SharedModule} from '../shared/shared.module';
import {GpRootComponent} from './gp-root/gp-root.component';
import {SelectionMenusComponent} from './selection-menus/selection-menus.component';
import {ProcessusComponent} from './processus/processus.component';
import {ButtonNextStepsComponent} from './button-next-steps/button-next-steps.component';
import {SelectionPlcsComponent} from './selection-plcs/selection-plcs.component';
import {ButtonCurrentStepComponent} from './button-current-step/button-current-step.component';
import {CoreModule} from '../core/core.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';


import {TableModule} from 'primeng/table';
import {CheckboxModule} from 'primeng/checkbox';
import {ListboxModule} from 'primeng/listbox';
import {DialogModule} from 'primeng/dialog';

import {CalendarModule} from 'primeng/calendar';
import {RadioButtonModule} from 'primeng/radiobutton';
import {SlideMenuModule} from 'primeng/slidemenu';
import {StepsModule} from 'primeng/steps';

@NgModule({
  imports: [
    CommonModule,
    GestionProcessusRoutingModule,
    SharedModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    CheckboxModule,
    ListboxModule,
    DialogModule,
    CalendarModule,
    RadioButtonModule,
    SlideMenuModule,
    StepsModule,
    ListboxModule,
  ],
  declarations: [
    GpRootComponent,
    SelectionMenusComponent,
    ProcessusComponent,
    ButtonNextStepsComponent,
    SelectionPlcsComponent,
    ButtonCurrentStepComponent
  ],
  exports: [
    ButtonNextStepsComponent,
    ButtonCurrentStepComponent
  ]
})
export class GestionProcessusModule { }
